import type { Tokens } from '@ovComponents/0-tokens/useTokens';
import { useTokens } from '@ovComponents/0-tokens/useTokens';
import { merge } from 'lodash-es';
import { createContext, useContext } from 'react';
import { UserContext } from './userContextProvider';

const TokenContext = createContext<Tokens>(useTokens({}));

const ThemeTokenContextProvider = ({ children }: { children: any }) => {
  const { activeOrganization } = useContext(UserContext);
  const override = merge(
    { ref: {}, sys: {}, comp: {} },
    activeOrganization.themeTokens,
  );
  const tokens = useTokens(override);

  return (
    <TokenContext.Provider value={tokens}>{children}</TokenContext.Provider>
  );
};

const ThemeTokenContextConsumer = TokenContext.Consumer;

const useThemeTokens = (compTokens?: any): Tokens => {
  const { activeOrganization } = useContext(UserContext);
  const tokens = useContext(TokenContext);

  return {
    ...tokens,
    comp: merge({}, compTokens, activeOrganization.themeTokens?.comp || {}),
  };
};

export { ThemeTokenContextConsumer, TokenContext, useThemeTokens };

export default ThemeTokenContextProvider;
